import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import {
  AdobePdfService,
  PdfViewerOptions,
} from 'src/app/services/adobe-pdf.service';

@Component({
  selector: 'app-pdf-viewer',
  imports: [CommonModule],
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
})
export class PdfViewerComponent implements OnInit {
  @Input() pdfUrl!: string;
  @Input() title!: string;
  @Input() containerId!: string;
  @Input() options?: PdfViewerOptions;
  @Input() thumbnailUrl!: string;
  @Input() smallHeight = false;

  isLightboxOpen = false;
  lightboxContainerId!: string;

  constructor(
    private adobePdfService: AdobePdfService,
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit(): void {
    if (!this.containerId) {
      this.containerId = `pdf-viewer-${Math.random()
        .toString(36)
        .substr(2, 9)}`;
    }
    this.lightboxContainerId = `${this.containerId}-lightbox`;
  }

  openLightbox(): void {
    const isMobile = this.breakpointObserver.isMatched('(max-width: 768px)');

    if (isMobile) {
      // Adobe PDF Embed doesn't have the greatest experience on mobile devices
      // so we will just open the PDF in a new tab and have the mobile browser handle it
      window.open(this.pdfUrl, '_blank');
    } else {
      this.adobePdfService.embedPdf(
        this.pdfUrl,
        '',
        this.title,
        this.options,
        'LIGHT_BOX'
      );
    }
  }
}
